module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-top-ties.c0ad3106.png";